module.exports = __webpack_public_path__ + "media/background1.e125ec44.webm";